import "./styles.css";
import { NavLink } from "react-router-dom";
import ContactSupportMailTo from "../ContactSupport/ContactSupportMailTo";

const SideMenuItem = ({
  to,
  label,
  iconDefault,
  iconActive,
  isExpanded = false,
}) => {
  if (!to) return null;
  const isActiveNav = window.location.pathname?.startsWith(to);
  const externalLink = to.startsWith("https://");
  const isMailto = to.startsWith("mailto:");
  return (
    <li className={isExpanded ? "expanded-list" : "collapse-list"}>
      {externalLink ? (
        <div className="row">
          <a
            href={to}
            target="_blank"
            rel="noopener noreferrer"
            className={`col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 align-self-center side-nav-link ${
              isExpanded ? "expanded" : "collapsed"
            }`}
          >
            <div className="d-flex align-items-center">
              <img
                className="nav-menu-icon"
                alt={label}
                src={iconDefault}
                title={!isExpanded ? label : ""}
                style={!isExpanded ? { margin: "auto" } : {}}
              />
              <span
                className={`nav-menu-text ${
                  isExpanded ? "d-inline-block" : "d-none"
                }`}
              >
                {label}
              </span>
            </div>
          </a>
        </div>
      ) : isMailto ? (
        <ContactSupportMailTo
          iconDefault={iconDefault}
          isExpanded={isExpanded}
          label={label}
        />
      ) : (
        <div className="row">
          <NavLink
            to={to}
            className={`col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 align-self-center side-nav-link ${
              isExpanded ? "expanded" : "collapsed"
            }`}
          >
            <div className="d-flex align-items-center">
              <img
                className="nav-menu-icon"
                alt="menu-icon"
                src={isActiveNav ? iconActive : iconDefault}
                title={!isExpanded ? label : ""}
                style={!isExpanded ? { margin: "auto" } : {}}
              />
              <span
                className={`nav-menu-text ${
                  isExpanded ? "d-inline-block" : "d-none"
                }`}
              >
                {label}
              </span>
            </div>
          </NavLink>
        </div>
      )}
    </li>
  );
};

export default SideMenuItem;
